import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {onMounted, PropType, ref} from "vue";
import "codemirror/mode/javascript/javascript"
import Codemirror from "codemirror-editor-vue3";
import {CodemirrorOptions} from "./typings";


export default /*@__PURE__*/_defineComponent({
  __name: 'VACodemirror',
  props: {
  value: String,
  options: {
    type: Object as PropType<CodemirrorOptions>
  }
},
  emits: ['update:value'],
  setup(__props, { emit: __emit }) {

const emit = __emit

const props = __props

const parseCode = () =>{
  console.log("value--------->", props.value)
  try{
    return JSON.stringify(JSON.parse(props.value), null, '  ')
  }catch (e) {
    return props.value
  }
}

onMounted(()=>{
  // 延时加载，解决不显示BUG
  setTimeout(() => {
    cmRef.value.refresh();
  }, 1)
})

const cmRef = ref()
const cmOptions: any = {
  mode: props.options?.mode || "text/javascript",
  theme: props.options?.theme || 'default',
  lineWrapping: true,
  autocorrect: true,
  smartIndent: true,
  autofocus: true,
  autocapitalize: true,
}

const change = (v: any) =>{
  emit('update:value', v)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Codemirror), {
    value: parseCode(),
    options: cmOptions,
    border: "",
    ref_key: "cmRef",
    ref: cmRef,
    height: __props.options?.height || '100%',
    width: "100%",
    onChange: change
  }, null, 8, ["value", "height"]))
}
}

})